import { Options } from '@angular-slider/ngx-slider';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';

@Component({
  selector: 'postd-info-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
})
export class RevenueCalculatorComponent {
  @Input() theme = 'light';

  listening: boolean;
  loggedIn: boolean;

  postdSettings: {
    cost: number;
    sold: number;
    soldDisplay?: number;
    share: 0.86;
    total?: number;
  };
  adPlatformSettings: {
    cpm: number;
    views: number;
    viewsDisplay?: number;
    share: number;
    total?: number;
  };

  commonConfigs = {
    connect: [true, false],
  };
  commonSliderOptions: Options = {
    hideLimitLabels: true,
    hidePointerLabels: true,
    showSelectionBar: true,
  };
  postdConfigs: Record<string, Options> = {
    cost: {
      ...this.commonSliderOptions,
      floor: 0.01,
      ceil: 1.0,
      step: 0.01,
    },
    sold: {
      ...this.commonSliderOptions,
      floor: 2,
      step: 0.1,
      ceil: 7, // 1 - 10,000,000 in log scale, denominator of 10
    },
  };
  adPlatformConfigs: Record<string, Options> = {
    cpm: {
      ...this.commonSliderOptions,
      floor: 1,
      ceil: 8,
      step: 0.01,
    },
    views: {
      ...this.commonSliderOptions,
      floor: 2,
      step: 0.1,
      ceil: 8, // 1 - 100,000,000 in log scale, denominator of 10
    },
    share: {
      ...this.commonSliderOptions,
      floor: 0.3,
      step: 0.01,
      ceil: 0.75,
    },
  };
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId) {
    this.postdSettings = {
      cost: 0.05,
      sold: 4,
      share: 0.86,
    };
    this.adPlatformSettings = {
      cpm: 3,
      views: 5, // 10000
      share: 0.45,
    };
    for (const config in this.postdConfigs) {
      if (this.postdConfigs[config]) {
        Object.assign(this.postdConfigs[config], this.commonConfigs);
      }
    }
    for (const config in this.adPlatformConfigs) {
      if (this.adPlatformConfigs[config]) {
        Object.assign(this.adPlatformConfigs[config], this.commonConfigs);
      }
    }
    this.isBrowser = isPlatformBrowser(platformId);

    this.update();
  }

  update(_event?: { value: number }) {
    this.postdSettings.soldDisplay = Math.round(Math.pow(10, this.postdSettings.sold));
    this.postdSettings.total =
      this.postdSettings.soldDisplay * this.postdSettings.cost * this.postdSettings.share;
    this.adPlatformSettings.viewsDisplay = Math.round(Math.pow(10, this.adPlatformSettings.views));
    this.adPlatformSettings.total =
      (this.adPlatformSettings.viewsDisplay *
        this.adPlatformSettings.cpm *
        this.adPlatformSettings.share) /
      1000;
  }
}
